import { Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

export const DetailsRowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 10px;

  .detail-header {
    display: flex;
    align-items: center;
    gap: 6px;

    > :first-child {
      font-size: 12px;
      color: #f78e1e;
    }

    > span {
      font-size: 10px;
      font-weight: 400;
      color: #8c8c8c;
    }
  }

  .detail-value {
    font-size: 10px;
    color: #000000;
    font-weight: normal;
    padding-left: 18px;

    &.value-na {
      color: #8c8c8c;
    }
  }
`;

export const StyledText = styled(Text)<{ $inline?: boolean; $isNA?: boolean }>`
  font-size: 10px !important;
  color: ${(props) => (props.$isNA ? '#8c8c8c' : '#000')} !important;
  font-weight: 400 !important;
  padding-left: 18px;

  .anticon-copy,
  .anticon-check {
    color: #f78e1e !important;
    font-size: 10px !important;
    border: 1px solid #f78e1e;
    padding: 2px;
    margin-left: 4px;
  }

  .ant-typography-copy {
    color: #f78e1e !important;
  }

  .ant-typography-copy:hover {
    color: #e67e22 !important;
  }
`;
